<template>
  <div class="accountSecurity">
   <div class="personal-box comWidth">
     <CenterNav/>
      <div class="personal-right">
       <NavT :titleS="titleS"/>
        <div class="rightmain">
         <div class="right-anquan">
         <!--<p class="title">用戶帳戶：18180195153</p>-->
         <div class="anquan-success">
          <ul>
           <li>
            <img src="../../../assets/icon/anquan2-icon4.png">
            <div class="title">
              <h5>郵箱綁定/修改</h5>
              <p>綁定后可保證帳戶安全</p>
            </div>
            <div class="zhuangtai" v-if="signInInformation.bound_email == false">
              <img src="../../../assets/icon/anquan2-icon1.png" >
              <p>
                你還未綁定郵箱，請綁定郵箱
              </p>
            </div>
            <div class="zhuangtai" v-if="signInInformation.bound_email == true">
               <img src="../../../assets/icon/anquan2-icon2.png">
               <p></p>
             </div>
            <a v-if="signInInformation.bound_email == false" @click="modifyEmail">綁定</a>
            <a v-if="signInInformation.bound_email == true"  @click="modifyEmail">修改</a>
            <div v-if="dialogEmailVisible">
              <el-dialog title="邮箱绑定/修改" :visible.sync="dialogEmailVisible" :lockScroll="false" @close='resetData'>
                <el-form :label-width="formLabelWidth" :model="modifyData">
                  <el-form-item label="邮箱"  required>
                    <el-input type="text" v-model="email" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="郵箱驗證碼" :label-width="formLabelWidth" required>
                    <el-input type="text" v-model="verificationCode" auto-complete="off" ></el-input>
                    <a class="sendCodeBox" v-if="signInInformation.bound_email == true">
                      <b class="to_havecode" ref="toHavecodeOne" v-if="toHavecodeOne" @click="emailModifyCode">點擊獲取</b>
                      <b class="Codecountdown" v-if="codecountdownOne">
                        <span ref="num_1">60</span>s获取
                      </b>
                    </a>
                    <a class="sendCodeBox" v-if="signInInformation.bound_email == false">
                      <b class="to_havecode" ref="toHavecodeOne" v-if="toHavecodeOne" @click="emailBindingCode">點擊獲取</b>
                      <b class="Codecountdown" v-if="codecountdownOne">
                        <span ref="num_1">60</span>s获取
                      </b>
                    </a>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="resetData">取 消</el-button>
                  <el-button type="primary" @click="emailModify" v-if="signInInformation.bound_email == true">確認修改</el-button>
                  <el-button type="primary" @click="emailModify" v-if="signInInformation.bound_email == false">確認綁定</el-button>
                </div>
              </el-dialog>
            </div>
          </li>

          <li>
            <img src="../../../assets/icon/anquan2-icon2.svg" >
            <div class="title">
              <h5>移動電話綁定/修改</h5>
              <p>綁定后可保證帳戶安全</p>
            </div>
            <div class="zhuangtai" v-if="signInInformation.bound_phone == false">
              <img src="../../../assets/icon/anquan2-icon1.png" >
              <p>
                你還未綁定移動電話，請綁定移動電話
              </p>
            </div>
            <div class="zhuangtai" v-if="signInInformation.bound_phone == true">
                <img src="../../../assets/icon/anquan2-icon2.png">
                <p></p>
              </div>
            <a v-if="signInInformation.bound_phone == false" @click="modifyTel">綁定</a>
            <a v-if="signInInformation.bound_phone == true"  @click="modifyTel">修改</a>
            <div v-if="dialogTelVisible">
              <el-dialog title="手机绑定/修改" :visible.sync="dialogTelVisible" :lockScroll="false" @close='resetData'>
                <el-form :label-width="formLabelWidth" :model="modifyData">
                  <el-form-item label="手機號"  required>
                    <el-input type="text" v-model="tel" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="手機號驗證碼" :label-width="formLabelWidth" required>
                    <el-input type="text" v-model="verificationCode" auto-complete="off" ></el-input>
                    <a class="sendCodeBox" v-if="signInInformation.bound_phone == true">
                      <b class="to_havecode" ref="toHavecodeTwo" v-if="toHavecodeTwo" @click="telModifyCode">點擊獲取</b>
                      <b class="Codecountdown" v-if="codecountdownTwo">
                        <span ref="num_2">60</span>s获取
                      </b>
                    </a>
                    <a class="sendCodeBox" v-if="signInInformation.bound_phone == false">
                      <b class="to_havecode" ref="toHavecodeTwo" v-if="toHavecodeTwo" @click="telBindingCode">點擊獲取</b>
                      <b class="Codecountdown" v-if="codecountdownTwo">
                        <span ref="num_2">60</span>s获取
                      </b>
                    </a>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="resetData">取 消</el-button>
                  <el-button type="primary" @click="telModify" v-if="signInInformation.bound_phone == true">確認修改</el-button>
                  <el-button type="primary" @click="telModify" v-if="signInInformation.bound_phone == false">確認綁定</el-button>
                </div>
              </el-dialog>
            </div>
          </li>
          <li>
            <img src="../../../assets/icon/anquan2-icon5.png">
             <div class="title">
               <h5>登錄密碼</h5>
                <p>互聯網帳戶存在被盜風險，建議您定期修改密碼以確保帳戶安全</p>
               </div>
              <div class="zhuangtai">
                <img src="../../../assets/icon/anquan2-icon2.png">
                 <p></p>
              </div>

            <a @click="modifyPassword">修改</a>

            <!--修改密码弹框-->
            <el-dialog title="修改密碼" :visible.sync="dialogFormVisible" :lockScroll="false" @close='resetData'>
              <el-form :label-width="formLabelWidth" :model="modifyData">
                <el-form-item label="原密碼"  required>
                  <el-input type="password" v-model="modifyData.oldPassword" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="新密碼" :label-width="formLabelWidth" required>
                  <el-input type="password" v-model="modifyData.password" auto-complete="off" @input="cipherStrength"></el-input>
                </el-form-item>

                <el-form-item label="密碼強度 " :label-width="formLabelWidth">
                  <div id="level" ref="level" class="qiangdu_box pw-strength">
                    <div class="pw-bar"></div>
                    <div class="pw-bar-on"></div>
                    <div class="pw-txt"></div>
                  </div>
                </el-form-item>

                <el-form-item label="確認密碼" :label-width="formLabelWidth" required>
                  <el-input type="password" v-model="modifyData.password_confirmation" auto-complete="off"></el-input>
                </el-form-item>

              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="resetData">取 消</el-button>
                <el-button type="primary" @click="confirmaModif">確認修改</el-button>
              </div>
            </el-dialog>
           </li>
         </ul>
        </div>
      </div>
     </div>
    </div>
   </div>
  </div>
</template>

<script>
  //md5
  import md5 from 'js-md5'
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //common.js
  import { intensityJudge } from '@/utils/common';
  //api
  import {setPass} from '@/api/signIn';
  import {userInformation , bindingCode , modifyCode ,modifyBinding } from '@/api/authentication';
  export default {
    name: 'AccountSecurity',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'帳戶安全',
        /*正则*/
        telRg:/^1[3,4,5,6,7,8,9]\d{9}$/,
        emailRg: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
        padReg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/, // 密码
        //修改弹框
        dialogFormVisible: false,//密码修改
        dialogEmailVisible: false,//邮箱修改绑定
        dialogTelVisible: false,//手机号修改绑定
        formLabelWidth: '120px',
        //密码绑定
        modifyData:{
          oldPassword:'',
          password:'',
          password_confirmation:'',
        },
        /*登陆后的用 户信息*/
        signInInformation:{},
        /*s*/
        toHavecodeOne:true,
        codecountdownOne:false,
        toHavecodeTwo:true,
        codecountdownTwo:false,
        verificationCode:'',//验证码
        isClick:true,
        /* 邮箱修改 */
        email:'',//用 户
        /* 手机号修改 */
        tel:'',//用 户
       /*验证key*/
        key:{
          verification_key:'',
          verification_code:'',
        },
        j:null
      }
    },
    methods:{

      /******修改密码******/
      //密码弹框
      modifyPassword(){
          this.dialogFormVisible = true
      },
      //密码强度
      cipherStrength(){
        var level = this.$refs.level;
        var newPas = this.modifyData.password;
        intensityJudge(level,newPas)
      },
      //确认修改
      confirmaModif(){
          if(!this.modifyData.oldPassword){
            this.$message.error('原始密碼不能為空');
          }else if(!this.modifyData.password){
            this.$message.error('新密碼不能為空');
          }else if(!this.padReg.test(this.modifyData.password)){
            this.$message.error('6-12位數字加字母');
          }else if(this.modifyData.password_confirmation != this.modifyData.password){
            this.$message.error('兩次密碼不一致');
          }else {
            setPass(this.modifyData).then(res=>{
              this.resetData()
              this.$store.dispatch('LogOut').then(() => {
                this.$message.success('修改成功 , 請重新登录 ');
                this.$router.push({
                  name:'SignIn'
                })
              }).catch(() => {});
              this.dialogFormVisible = false;
            })
          }

      },

      /******邮箱修改绑定******/
      modifyEmail(){
        this.dialogEmailVisible = true
      },
      //获取修改邮箱验证码
      emailModifyCode(){
          var tip = {
              mo:'請輸入正確的郵箱',
              suc:'发送成功',
              Reg:this.emailRg, //验证
            state:'binding', //获取验证需要的参数
              str:this.email, //需要修改的手机或者邮箱
          isClick:this.isEmail, //需要修改的手机或者邮箱
            toHavecode:this.toHavecodeOne, //点击获取
            codecountdown:this.codecountdownOne, //s
          };
          this.getCodeOne(tip)
      },
      //获取绑定邮箱验证码
      emailBindingCode(){
        var tip = {
          mo:'請輸入正確的郵箱',
          suc:'发送成功',
          Reg:this.emailRg, //验证
          state:'binding', //获取验证需要的参数
          str:this.email, //需要修改的手机或者邮箱
        };
        this.getCodeOne(tip)
      },
      //邮箱修改
      emailModify(){
        var tip = {
          mo:'請輸入正確的郵箱',
          bo:'請輸入正確的郵箱驗證碼',
          suc:'修改成功',
          Reg:this.emailRg, //验证
          str:this.email, //需要修改的手机或者邮箱
          code:this.verificationCode//验证码
        };
          this.modifyBing(tip)
      },

      /******手机修改绑定******/
      modifyTel(){
        this.dialogTelVisible = true
      },
      //获取修改手机验证码
      telModifyCode(){
        var tip = {
          mo:'請輸入正確的手機號',
          suc:'发送成功',
          Reg:this.telRg, //验证
          state:'binding', //获取验证需要的参数
          str:this.tel, //需要修改的手机或者邮箱
        };
        this.getCodeTwo(tip)
      },
      //获取绑定手机验证码
      telBindingCode(){
        var tip = {
          mo:'請輸入正確的手機號',
          suc:'发送成功',
          Reg:this.telRg, //验证
          state:'binding', //获取验证需要的参数
          str:this.tel, //需要修改的手机或者邮箱
        };
        this.getCodeTwo(tip)
      },
      //手机修改
      telModify(){
        var tip = {
          mo:'請輸入正確的手機號',
          bo:'請輸入正確的手機號驗證碼',
          suc:'修改成功',
          Reg:this.telRg, //验证
          str:this.tel, //需要修改的手机或者邮箱
          code:this.verificationCode//验证码
        };
        this.modifyBing(tip)
      },

      //邮箱验证码获取
      getCodeOne(tip){
//          if(!(tip.Reg.test(tip.str))){
//            this.$message.error(tip.mo);
//          }else {
//              var params = {
//                username:tip.str,
//                action:tip.state
//              };
//            modifyCode(params).then(res =>{
//              this.$message.success(tip.suc);
//              this.key.verification_key = res.data.key;
//              this.key.verification_code = res.data.code;
//              if(this.isClick){
                this.isClick = false;
                this.toHavecodeOne = false;
                this.codecountdownOne = true;
                var time_s = 60;
                this.j = setInterval(() => {
                  time_s --;
                  this.$refs.num_1.textContent = time_s;
                  if(time_s <= 0){
                    this.isClick = true;
                    this.toHavecodeOne = true;
                    this.codecountdownOne = false;
                    window.clearInterval(this.j);
                  }
                },1000);
//              }
//            })
//          }
      },

      //手机验证码获取
      getCodeTwo(tip){
//          if(!(tip.Reg.test(tip.str))){
//            this.$message.error(tip.mo);
//          }else {
//              var params = {
//                username:tip.str,
//                action:tip.state
//              };
//            modifyCode(params).then(res =>{
//              this.$message.success(tip.suc);
//              this.key.verification_key = res.data.key;
//              this.key.verification_code = res.data.code;
              if(this.isClick){
                this.isClick = false;
                this.toHavecodeTwo = false;
                this.codecountdownTwo = true;
                var time_s = 60;
                this.j = setInterval(() => {
                  time_s --;
                  this.$refs.num_2.textContent = time_s;
                  if(time_s <= 0){
                    this.isClick = true;
                    this.toHavecodeTwo = true;
                    this.codecountdownTwo = false;
                    window.clearInterval(this.j);
                  }
                },1000);
              }
//            })
//          }
      },

      /*修改或者绑定*/
      modifyBing(tip ){
        if(!(tip.Reg.test(tip.str))){
          this.$message.error(tip.mo);
        }else if(md5(tip.code) != this.key.verification_code){
            this.$message.error(tip.bo)
        }else {
            this.key.verification_code = tip.code;
          modifyBinding(this.key).then(res =>{
            this.$message.success(tip.suc)
            this.resetData() // 重置
            this.getInformation()
          })
        }
      },


      /*获取登陆后的个人信息*/
      getInformation(){
        userInformation().then(res =>{
          this.signInInformation = res.data;
        })
      },


      /*重置数据*/
      resetData(){
        this.dialogFormVisible = false //密码修改
        this.dialogEmailVisible = false //邮箱修改绑定
        this.dialogTelVisible = false //手机号修改绑定
        this.modifyData = { //密码绑定
          oldPassword:'',
          password:'',
          password_confirmation:'',
        }
        this.key = { // 验证key
          verification_key:'',
          verification_code:'',
        }
        this.email = '' // 邮箱
        this.tel = '' // 手机号
        this.verificationCode = '' // 验证码
        this.isClick = true // 验证码计时
        this.toHavecodeOne = true
        this.codecountdownOne = false
        this.toHavecodeTwo = true
        this.codecountdownTwo = false
        window.clearInterval(this.j);
      }
    },

    created(){
        //获取登陆后的个人信息
      this.getInformation();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../css/accountSecurity.less";
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/accountSettingPage/AccountSecurity.vue